/**
 * 챗봇 입력창.
 *
 * - Enter: 전송 / Shift+Enter: 줄바꿈
 * - 응답 streaming 중에는 비활성
 * - 한도 초과 시에도 비활성 + 안내
 * - 최대 글자 수 표시
 */
import React, { useState } from "react";
import { Box, IconButton, TextField } from "@mui/material";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { ds } from "../../styles/designSystem";

const MAX_CHARS = 4000;

export default function ChatbotInput({ disabled, onSend, placeholder }) {
    const [value, setValue] = useState("");

    const handleSend = () => {
        const text = value.trim();
        if (!text || disabled) return;
        if (text.length > MAX_CHARS) return;
        onSend?.(text);
        setValue("");
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };

    const over = value.length > MAX_CHARS;
    return (
        <Box sx={{
            display: "flex", alignItems: "flex-end", gap: 1,
            px: 1.5, py: 1, borderTop: `1px solid ${ds.colors.border}`, bgcolor: ds.colors.bg,
        }}>
            <TextField
                size="small"
                multiline
                maxRows={5}
                fullWidth
                value={value}
                onChange={(e) => setValue(e.target.value)}
                onKeyDown={handleKeyDown}
                disabled={disabled}
                placeholder={placeholder || "메시지를 입력하세요 (Shift+Enter 줄바꿈)"}
                sx={{ "& .MuiOutlinedInput-root": { fontSize: 13.5 } }}
                helperText={over ? `최대 ${MAX_CHARS}자` : null}
                error={over}
            />
            <IconButton
                color="primary"
                onClick={handleSend}
                disabled={disabled || !value.trim() || over}
                size="medium"
            >
                <SendRoundedIcon />
            </IconButton>
        </Box>
    );
}
